import styled from 'styled-components';

const PageContainer = styled.div`
  position: relative;
  min-height: calc(100vh - 134px);
  width: 100%;
  /* padding: 0 50px; */
  padding: 20px 10px;
  padding-bottom: 10px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
  padding-top: 40px;
  @media screen and (max-width: 1440px) {
    padding-bottom: 10px;
  }
`;

export default PageContainer;
